export default "__VITE_ASSET__C3__AenQ__"